import { MantineTheme } from '@mantine/core';
import { AutocompleteSubmitData, InputChangeArg, InputSubmitArg } from 'types/inputs.ts';
import { autocompleteChangeArg, autocompleteFieldDefault, autocompleteSubmitArg } from 'utils/inputs.tsx';
import {
    DocumentWriteOffAutocompleteKey,
    DocumentWriteOffFormGlobal,
    DocumentWriteOffWarehouseAutocompleteKey,
    DocumentWriteOffWarehouseFormBody,
    DocumentWriteOffWarehouseFormGlobal
} from 'components/Supply/DocumentWriteOff/DocumentWriteOff.types.ts';

// *
// STATUS
// *

export type DocumentWriteOffStatusStatus = 'PREPARATION' | 'CONDUCTED' | 'CANCELLED'

export const documentWriteOffStatusColors = (documentWriteOffStatus: DocumentWriteOffStatusStatus ,theme: MantineTheme) => {
    switch (documentWriteOffStatus) {
        case 'PREPARATION': return { color: theme.colors.info[5], background:theme.fn.rgba(theme.colors.info[5], 0.2) }
        case 'CONDUCTED': return { color: theme.colors.success[5], background:theme.fn.rgba(theme.colors.success[5], 0.2) }
        case 'CANCELLED': return { color: theme.colors.red[5], background:theme.fn.rgba(theme.colors.red[5], 0.2) }
        default: return { color: theme.colors.natural[6], background:theme.fn.rgba(theme.colors.natural[6], 0.2) }
    }
}

// *
// STORE
// *

export const documentWriteOffFormBodyInitialState: DocumentWriteOffWarehouseFormGlobal = {
    warehouse: autocompleteFieldDefault,
}

export const documentWriteOffFormGlobalDefaultValues: DocumentWriteOffFormGlobal = {
    warehouse: autocompleteFieldDefault,
    project: autocompleteFieldDefault,
    name: '',
    createdAt: [],
}

// *
// INPUT PROCESSING FUNCS
// *

// edit

export type DocumentWriteOffAutocompleteSubmitData = AutocompleteSubmitData & { label: string }

export const onDocumentWriteOffWarehouseBodyAutocompleteSubmit = ({
    key,
    setFormValue,
}: InputSubmitArg<DocumentWriteOffWarehouseAutocompleteKey, DocumentWriteOffWarehouseFormBody>) =>
    (data: DocumentWriteOffAutocompleteSubmitData) => {
        if(data.value && data.label) {
            setFormValue(key, autocompleteSubmitArg({ id: data.value, value: data.label }))
            return
        }
        setFormValue(key, autocompleteSubmitArg(data))
    }
export const onDocumentWriteOffWarehouseBodyAutocompleteChange = ({
    formData,
    key,
    setFormValue,
}: InputChangeArg<DocumentWriteOffWarehouseAutocompleteKey, DocumentWriteOffWarehouseFormBody>) =>
    (label: string) => {
        if (formData[key]?.name !== label) {
            setFormValue(key, autocompleteChangeArg(label))
        }
    }

// filter

export const onDocumentWriteOffBodyAutocompleteSubmit = ({
    key,
    setFormValue,
}: InputSubmitArg<DocumentWriteOffAutocompleteKey, DocumentWriteOffFormGlobal>) =>
    (data: DocumentWriteOffAutocompleteSubmitData) => {
        if(data.value && data.label) {
            setFormValue(key, autocompleteSubmitArg({ id: data.value, value: data.label }))
            return
        }
        setFormValue(key, autocompleteSubmitArg(data))
    }
export const onDocumentWriteOffBodyAutocompleteChange = ({
    formData,
    key,
    setFormValue,
}: InputChangeArg<DocumentWriteOffAutocompleteKey, DocumentWriteOffFormGlobal>) =>
    (label: string) => {
        if (formData[key]?.name !== label) {
            setFormValue(key, autocompleteChangeArg(label))
        }
    }
